(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('occupationCrews', {
                parent: 'app',
                url: '/occupationCrew/list',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/occupationCrew/occupationCrews.html',
                        controller: 'occupationCrewsCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }],
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('occupationCrews')
                            }],
                            'occupationCrews': ['occupationCrewService','$stateParams', function (occupationCrewService,$stateParams) {
                                return occupationCrewService.getPageOccupationCrews($stateParams.page, $stateParams.size)
                            }]
                        }
                    }
                }
            })
            .state('occupationCrewNew', {
                parent: 'app',
                url: '/occupationCrew/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/occupationCrew/occupationCrewNew.html',
                        controller: 'occupationCrewNewCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }],
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('occupationCrews')
                            }]
                        }
                    }
                }
            })
            .state('occupationCrewEdit', {
                parent: 'app',
                url: '/occupationCrew/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/flightControl/airCrew/occupationCrew/occupationCrewEdit.html',
                        controller: 'occupationCrewEditCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }],
                            'tabAdminFlights': ['tabService', function(tabService){
                                return tabService.getTabOccupationCrew('occupationCrews')
                            }],
                            'occupationCrew': ['occupationCrewService', '$stateParams', function (occupationCrewService, $stateParams) {
                                return occupationCrewService.getOccupationCrewById($stateParams.id)
                            }]
                        }
                    }
                }
            })
            .state('occupationCrewDelete', {
                parent: 'occupationCrews',
                url: '/occupationCrew/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/airCrew/occupationCrew/occupationCrewDelete.html',
                        controller: 'occupationCrewDeleteCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['aircrew']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('occupationCrews', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

